var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPatternDesign2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 131,
    height: 42,
    viewBox: "0 0 131 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.94 27.66C37.5781 27.66 43.77 21.4681 43.77 13.83C43.77 6.19192 37.5781 0 29.94 0C22.3019 0 16.11 6.19192 16.11 13.83C16.11 21.4681 22.3019 27.66 29.94 27.66Z",
    fill: "#F0DB4F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M96.8299 13.8001L103.66 6.96008L101.65 4.95007L92.7999 13.8001L101.65 22.6501L103.66 20.6301L96.8299 13.8001Z",
    fill: "#4390E8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M108.76 13.8001L115.59 6.96008L113.58 4.95007L104.73 13.8001L113.58 22.6501L115.59 20.6301L108.76 13.8001Z",
    fill: "#4390E8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M120.83 13.8001L127.67 6.96008L125.65 4.95007L116.81 13.8001L125.65 22.6501L127.67 20.6301L120.83 13.8001Z",
    fill: "#4390E8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M72.8299 13.8001L79.6599 6.96008L77.6499 4.95007L68.7999 13.8001L77.6499 22.6501L79.6599 20.6301L72.8299 13.8001Z",
    fill: "#4390E8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M84.76 13.8001L91.59 6.96008L89.58 4.95007L80.73 13.8001L89.58 22.6501L91.59 20.6301L84.76 13.8001Z",
    fill: "#4390E8"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1.93 41.67C0.87 41.67 0 40.8101 0 39.7401C0 38.6801 0.86 37.8101 1.93 37.8101C3 37.8101 3.86 38.6701 3.86 39.7401C3.86 40.8101 3 41.67 1.93 41.67Z",
    fill: "#B5B5B5"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M20.07 41.67C19.01 41.67 18.14 40.8101 18.14 39.7401C18.14 38.6801 19 37.8101 20.07 37.8101C21.14 37.8101 22 38.6701 22 39.7401C22 40.8101 21.13 41.67 20.07 41.67Z",
    fill: "#B5B5B5"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M38.2 41.67C37.14 41.67 36.27 40.8101 36.27 39.7401C36.27 38.6801 37.13 37.8101 38.2 37.8101C39.26 37.8101 40.13 38.6701 40.13 39.7401C40.13 40.8101 39.27 41.67 38.2 41.67Z",
    fill: "#B5B5B5"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M56.34 41.67C55.28 41.67 54.41 40.8101 54.41 39.7401C54.41 38.6801 55.27 37.8101 56.34 37.8101C57.4 37.8101 58.27 38.6701 58.27 39.7401C58.27 40.8101 57.4 41.67 56.34 41.67Z",
    fill: "#B5B5B5"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M74.48 41.67C73.42 41.67 72.55 40.8101 72.55 39.7401C72.55 38.6801 73.41 37.8101 74.48 37.8101C75.54 37.8101 76.41 38.6701 76.41 39.7401C76.4 40.8101 75.54 41.67 74.48 41.67Z",
    fill: "#B5B5B5"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M92.6099 41.67C91.5499 41.67 90.6799 40.8101 90.6799 39.7401C90.6799 38.6801 91.5399 37.8101 92.6099 37.8101C93.6699 37.8101 94.5399 38.6701 94.5399 39.7401C94.5399 40.8101 93.6699 41.67 92.6099 41.67Z",
    fill: "#B5B5B5"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M110.75 41.67C109.69 41.67 108.82 40.8101 108.82 39.7401C108.82 38.6801 109.68 37.8101 110.75 37.8101C111.81 37.8101 112.68 38.6701 112.68 39.7401C112.67 40.8101 111.81 41.67 110.75 41.67Z",
    fill: "#B5B5B5"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M128.88 41.67C127.82 41.67 126.95 40.8101 126.95 39.7401C126.95 38.6801 127.81 37.8101 128.88 37.8101C129.94 37.8101 130.81 38.6701 130.81 39.7401C130.81 40.8101 129.95 41.67 128.88 41.67Z",
    fill: "#B5B5B5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatternDesign2);
export default __webpack_public_path__ + "static/media/pattern-design-2.fff7d26632fb8dbef0b77cb419d69150.svg";
export { ForwardRef as ReactComponent };